// features/ApprovalRequest/ApprovalRequestAddEditView/store.ts
import { makeAutoObservable, runInAction } from "mobx";
import { validate } from "./valid";
import i18n from "i18next";
import MainStore from "MainStore";
import dayjs, { Dayjs } from 'dayjs';
import {
    getApprovalRequest,
    createApprovalRequest,
    updateApprovalRequest, changeStatus
} from "api/ApprovalRequest";
import {getstatuses} from "../../../api/status";
import {boolean} from "yup";

class ApprovalRequestAddEditStore {
  id = 0;
  bga_application_number = "";
  organization_id = 0;
  applicant_name = "";
  approval_type = "";
  current_status = "";
  priority = "";
  operator_id = null;
  received_date: Dayjs | null = null;
  deadline_date: Dayjs | null = null;
  completed_date: Dayjs | null = null;
    description = "";
  created_at = "";
  updated_at = "";
  created_by = null;
  updated_by = null;
    statuses = [];
    disableEdit = false;
  // Error fields
  errorbga_application_number = "";
  errororganization_id = "";
  errorapplicant_name = "";
  errorapproval_type = "";
  errorcurrent_status = "";
  errorpriority = "";
  erroroperator_id = "";
  errorreceived_date = "";
  errordeadline_date = "";
  errorcompleted_date = "";
  errordescription = "";

  organisation =[]
  operators =[]

  constructor() {
    makeAutoObservable(this);
  }

  clearStore() {
    runInAction(() => {
      this.id = 0;
      this.bga_application_number = "";
      this.organization_id = 0;
      this.applicant_name = "";
      this.approval_type = "";
      this.current_status = "";
      this.priority = "";
      this.operator_id = null;
      this.received_date = null;
      this.deadline_date = null;
      this.completed_date = null;
      this.description = "";
      this.created_at = "";
      this.updated_at = "";
      this.created_by = null;
      this.updated_by = null;
      this.errorbga_application_number = "";
      this.errororganization_id = "";
      this.errorapplicant_name = "";
      this.errorapproval_type = "";
      this.errorcurrent_status = "";
      this.errorpriority = "";
      this.erroroperator_id = "";
      this.errorreceived_date = "";
      this.errordeadline_date = "";
      this.errorcompleted_date = "";
        this.statuses = [];
    });
  }

  handleChange(event) {
    this[event.target.name] = event.target.value;
    validate(event);
  }

    nextStatuses = () => {
        var current = this.statuses.find(s => s.code === this.current_status)?.code
        switch (current) {
            case "pending": return ["in_progress"];
            case "in_progress": return ["completed", "completed_without_eds", "completed_without_payment", "rejected"];
            case "completed_without_payment": return ["completed"];
            default: return [];
        }
    };

    setStatus(code: string) {
        this.current_status = code;
        // completed_without_payment не терминальный — можно перейти в completed
        const terminalStatuses = ["completed", "rejected", "completed_without_eds"];
        if (terminalStatuses.includes(code)) {
            this.disableEdit = true;
        }
    }

  onSaveClick = async (onSaved: (id: number) => void) => {
    let canSave = true;
    let event: { target: { name: string; value: any } } = {
      target: { name: "id", value: this.id }
    };
    canSave = validate(event) && canSave;
    event = { target: { name: "organization_id", value: this.organization_id } };
    canSave = validate(event) && canSave;
    event = { target: { name: "bga_application_number", value: this.bga_application_number } };
    canSave = validate(event) && canSave;
    event = { target: { name: "applicant_name", value: this.applicant_name } };
    canSave = validate(event) && canSave;

    if (canSave) {
      try {
        MainStore.changeLoader(true);
        var data = {
          id: this.id,
          bga_application_number: this.bga_application_number,
          organization_id: this.organization_id,
          applicant_name: this.applicant_name,
          approval_type: this.approval_type,
          current_status: this.current_status,
          priority: this.priority,
          operator_id: this.operator_id,
          received_date: this.received_date ? this.received_date.toISOString() : null,
          deadline_date: this.deadline_date ? this.deadline_date.toISOString() : null,
          completed_date: this.completed_date ? this.completed_date.toISOString() : null,
            description: this.description
        };

        const response = data.id === 0
          ? await createApprovalRequest(data)
          : await updateApprovalRequest(data);

        if (response.status === 201 || response.status === 200) {
          onSaved(response.data.id);
          if (data.id === 0) {
            this.id = response.data.id;
            MainStore.setSnackbar(i18n.t("message:snackbar.successSave"), "success");
          } else {
            MainStore.setSnackbar(i18n.t("message:snackbar.successEdit"), "success");
          }
        } else {
          throw new Error();
        }
      } catch (err) {
        MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
      } finally {
        MainStore.changeLoader(false);
      }
    } else {
      MainStore.openErrorDialog(i18n.t("message:error.alertMessageAlert"));
    }
  };

  loadApprovalRequest = async (id: number) => {
    try {
      MainStore.changeLoader(true);
      const response = await getApprovalRequest(id);
      if ((response.status === 201 || response.status === 200) && response?.data !== null) {
        runInAction(() => {
          this.bga_application_number = response.data.bga_application_number || "";
          this.organization_id = response.data.organization_id;
          this.applicant_name = response.data.applicant_name || "";
          this.approval_type = response.data.approval_type || "";
          this.current_status = response.data.current_status ? response.data.current_status : "pending";
          this.priority = response.data.priority || "";
          this.operator_id = response.data.operator_id;
          this.received_date = response.data.received_date ? dayjs(response.data.received_date) : null;
          this.deadline_date = response.data.deadline_date ? dayjs(response.data.deadline_date) : null;
          this.completed_date = response.data.completed_date ? dayjs(response.data.completed_date) : null;
          this.description = response.data.description || "";
          this.created_at = response.data.created_at || "";
          this.updated_at = response.data.updated_at || "";
          this.created_by = response.data.created_by;
          this.updated_by = response.data.updated_by;
          this.setStatus(this.current_status);
        });
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  };

    loadstatuses = async () => {
        try {
            MainStore.changeLoader(true);
            const response = await getstatuses();
            if ((response.status === 201 || response.status === 200) && response?.data !== null) {
                runInAction(() => {
                    this.statuses = response.data;
                });
            } else {
                throw new Error();
            }
        } catch (err) {
            MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
        } finally {
            MainStore.changeLoader(false);
        }
    };

    changeStatus = async (code: string) => {
        try {
            MainStore.changeLoader(true);
            const response = await changeStatus(this.id, code);
            if ((response.status === 201 || response.status === 200) && response?.data !== null) {
                runInAction(() => {
                    if(response.data.errors.length > 0) {
                        MainStore.openErrorDialog(response.data.errors[0].message);
                    }
                    else {
                        this.setStatus(code);
                    }
                })
            } else {
                throw new Error();
            }
        } catch (err) {
            MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
        } finally {
            MainStore.changeLoader(false);
        }
    };

  async doLoad(id: number) {
      await this.loadstatuses();
    if (id == null || id == 0) {
      return;
    }
    this.id = id;
    this.loadApprovalRequest(id);
  }
}

export default new ApprovalRequestAddEditStore();